import React, { memo, useState, useCallback, useEffect, useRef } from "react";
import styled from "styled-components";
import "../../assets/selected_top.png";
import { useTranslation } from "react-i18next";
import icon_line from "assets/icon_line.png";
import ItemRatingPoint from "containers/rating/ItemRatingPoint";
import ModalLoading from "components/modal/Loading";
import ServiceBase from "utils/ServiceBase";
import { notification } from "antd";
import { CheckCircleFilled } from "@ant-design/icons";
import { toast } from "react-toastify";
import { useSelector, useDispatch } from "react-redux";
import { setIsCheckComment } from "redux/action";
import icon_cancel_dialog from "assets/icon_cancel_dialog.png";
import ItemAnswer from "containers/rating/ItemAnswer";
import ItemAnswerType from "containers/rating/ItemAnswerType";
import CryptoJS from "crypto-js";
import { checkNetworkConnection } from "utils/ServiceBase";
import {
  setOpenNoInternetModal,
  pushApiErrorData,
  setApiErrorOpen,
} from "redux/action";
import { webEventExtraParams } from "utils";

const RatingOnModal = memo(({ className, onClose, listRating }) => {
  const { t } = useTranslation("translation");
  const [note, setNote] = useState("");
  const [listPoint, setListPoint] = useState([]);
  const [listSurvey, setListSurvey] = useState([]);
  const [survey, setSurvey] = useState({});
  const dispatch = useDispatch();
  const isEnableRefPoint = useRef(false);
  const isEnableRefSurvey = useRef(false);
  const isEnableRefListSurvey = useRef(false);
  const countSurveyRef = useRef(0);
  const setNoteForProduct = useCallback((noteValue) => {
    setNote(noteValue);
  });
  const listServeyRef = useRef("");
  const isLanguageEnglish = useSelector(
    (state) => state.rootReducer.isLanguageEnglish,
  );
  const infoUserTgs = useSelector((state) => state.rootReducer.infoUserTgs);
  const consent = localStorage.getItem("cookieConsent");

  const onSelectedAnswer = (item, itemAnswer, itemQuestion, index) => {
    item?.["questions"].forEach((itemAs) => {
      if (itemQuestion.id === itemAs.id) {
        itemAs?.["answers"].forEach((itemAdd) => {
          if (itemAnswer.id === itemAdd.id) {
            itemAdd.isSelected = true;
          } else {
            itemAdd.isSelected = false;
          }
          if (itemAdd.isSelected) {
            countSurveyRef.current++;
          }
        });
      }
    });
    isEnableRefListSurvey.current =
      countSurveyRef.current >= item?.["questions"]?.length;
    setListSurvey([...listSurvey]);
  };

  const onSelectedAnswerType = (itemAnswer, itemQuestion, index) => {
    survey?.["questions"].forEach((itemAs) => {
      if (itemQuestion.id === itemAs.id) {
        itemAs?.["answers"].forEach((itemAdd) => {
          if (itemAnswer.id === itemAdd.id) {
            itemAdd.isSelected = true;
            itemQuestion.isSelected = true;
          } else {
            itemAdd.isSelected = false;
          }
        });
      }
    });
    isEnableRefSurvey.current = true;
    survey?.["questions"].forEach((itemAs) => {
      if (itemAs?.isSelected === undefined || itemAs?.isSelected === false) {
        isEnableRefSurvey.current = false;
      }
    });
    setSurvey({ ...survey });
  };

  const [loading, setLoading] = useState(false);
  const homeBrand = useSelector((state) => state.rootReducer.homeBrand);

  const onSubmitRating = () => {
    if (
      isEnableRefPoint.current &&
      isEnableRefSurvey.current &&
      isEnableRefListSurvey.current
    ) {
      let payload;
      let point = {};
      let listSurveys = [];
      let questions = [];
      let questionsOne = [];
      survey?.["questions"].forEach((itemAs) => {
        let question = {};
        let answers = [];
        listServeyRef.current += itemAs.name;
        itemAs?.["answers"].forEach((itemAdd) => {
          if (itemAdd.isSelected) {
            listServeyRef.current += ":" + itemAdd.name + "/";
            answers.push({
              id: itemAdd?.["id"],
              "question-id": itemAdd?.["question-id"],
            });
          }
        });
        question = {
          id: itemAs?.["id"],
          answers: answers,
        };
        questions.push(question);
      });
      listSurveys.push({
        id: survey?.["id"],
        questions: questions,
      });

      listSurvey?.forEach((item, i) => {
        item?.["questions"].forEach((itemAs) => {
          let question = {};
          let answers = [];
          listServeyRef.current += itemAs.name;
          itemAs?.["answers"].forEach((itemAdd) => {
            if (itemAdd.isSelected) {
              listServeyRef.current += ":" + itemAdd.name + "/";
              answers.push({
                id: itemAdd?.["id"],
                "question-id": itemAdd?.["question-id"],
              });
            }
          });
          question = {
            id: itemAs?.["id"],
            answers: answers,
          };
          questionsOne.push(question);
        });
        listSurveys.push({
          id: item?.["id"],
          questions: questionsOne,
        });
      });

      listPoint?.forEach((item, i) => {
        if (item.isSelected === true) {
          point = item;
        }
      });
      payload = {
        guid: `{${homeBrand?.qrCode}}`,
        "rating-point": point,
        "rating-note": note,
        "app-code": "QrCode",
        version: "",
        surveys: listSurveys,
      };
      submitRating(payload);
    }
  };

  const onCloseModalRating = () => {
    onClose();
  };

  const handleCheckNetworkConnect = () => {
    if (checkNetworkConnection()) return true;
    else {
      dispatch(setOpenNoInternetModal(true));
      return false;
    }
  };

  const submitCdp = (payload) => {
    let dim = {};
    if (infoUserTgs && consent !== "accepted") {
      dim = {
        customers: {
          customer_id: CryptoJS.MD5(infoUserTgs?.["cellphone"]).toString(),
          name: infoUserTgs?.["first-name"] + " " + infoUserTgs?.["last-name"],
          email: infoUserTgs?.["email"],
          phone: infoUserTgs?.["cellphone"],
          ggg_user_id: infoUserTgs?.["customer-number"],
        },
        rating: {
          id: payload?.["rating-point"]?.id,
          name: payload?.["rating-point"]?.id,
          customer_id: CryptoJS.MD5(infoUserTgs?.["cellphone"]).toString(),
          customer_phone: infoUserTgs?.["cellphone"],
          feedback: payload?.["rating-note"],
          survey: listServeyRef.current,
          rating_score: payload?.["rating-point"]?.points,
          parent: "false",
          restaurant_id: homeBrand?.restaurantCode,
          object_id: homeBrand?.qrCode,
          object_name: homeBrand?.qrCode,
          object_type: "rating",
        },
        purchase: {
          id: homeBrand.qrCode,
          name: homeBrand.qrCode,
        },
      };
    } else {
      dim = {
        rating: {
          id: payload?.["rating-point"]?.id,
          name: payload?.["rating-point"]?.name,
          feedback: payload?.["rating-note"],
          survey: listServeyRef.current,
          rating_score: payload?.["rating-point"]?.points,
          parent: "false",
          restaurant_id: homeBrand?.restaurantCode,
          object_id: homeBrand?.qrCode,
          object_name: homeBrand?.qrCode,
          object_type: "rating",
        },
        purchase: {
          id: homeBrand.qrCode,
          name: homeBrand.qrCode,
        },
      };
    }
    window.web_event.track("user", "feedback", {
      dims: dim,
      extra: {
        order_id: homeBrand?.qrCode,
        language: isLanguageEnglish ? "eng" : "vie",
        ggg_user_id: infoUserTgs?.["customer-number"],
        ...webEventExtraParams(homeBrand)
      },
    });
  };

  const submitRating = async (payload) => {
    if (!handleCheckNetworkConnect()) return;
    setLoading(true);
    console.log(payload);
    const response = await ServiceBase.requestJson({
      method: "POST",
      url: `/ggg/api/v4.0/cs/ratingFromQrOrder`,
      data: {
        guid: payload?.["guid"],
        "rating-point": payload?.["rating-point"]?.["points"],
        "rating-note": payload?.["rating-note"],
        "app-code": payload?.["app-code"],
        version: payload?.["version"],
        "rating-list-comment": payload?.["rating-list-comment"],
        surveys: payload?.surveys,
        "customer-name": infoUserTgs
          ? infoUserTgs?.["first-name"] + " " + infoUserTgs?.["last-name"]
          : "",
        "customer-cellphone": infoUserTgs ? infoUserTgs?.["cellphone"] : "",
      },
    });
    if (response?.value?.code === "200") {
      submitCdp(payload);
      dispatch(setIsCheckComment(homeBrand?.qrCode));
      setLoading(false);
      onCloseModalRating();
      notification.open({
        message: `${t("notifyContentSubmitRatingSuccess")}`,
        description: " ",
        icon: (
          <CheckCircleFilled
            style={{ color: "#47C751", background: "#ffffff" }}
          />
        ),
      });
    } else {
      setLoading(false);
      if (response?.value?.code === "401") {
        return toast.error(
          response?.value?.mess ||
            response?.value?.message ||
            response?.value?.code,
        );
      } else {
        if (response?.code === "ECONNABORTED") {
          const url = `/ggg/api/v4.0/cs/ratingFromQrOrder`;
          handlePushApiError({ url, time: Date.now() });
          notification["error"]({
            key: "internalServerError",
            message: t("internalServerError"),
            duration: 15,
            description: (
              <span style={{ color: "#2083DA" }} onClick={handleShowApiErrors}>
                {t("forDev")}
              </span>
            ),
          });
        } else {
          return toast.error(response?.value?.mess || response?.value?.message);
        }
      }
    }
  };

  const handlePushApiError = (api) => {
    dispatch(pushApiErrorData([api]));
  };

  const handleShowApiErrors = () => {
    notification.close("internalServerError");
    dispatch(setApiErrorOpen(true));
  };

  const onSelected = (item, index) => {
    listPoint?.map((itemPoint) => {
      if (itemPoint?.["points"] === item?.["points"]) {
        itemPoint.isSelected = true;
        isEnableRefPoint.current = true;
      } else {
        itemPoint.isSelected = false;
      }
    });

    setListPoint([...listPoint]);
  };

  useEffect(() => {
    if (listRating) {
      setLoading(false);
      var listPoint = [];
      if (listRating !== "") {
        listRating?.["lst-point"].forEach((item, i) => {
          listPoint.push(item);
        });
        listRating?.["lst-survey"].forEach((item, i) => {
          if (item?.["order-no"] !== 1) {
            listSurvey.push(item);
          } else {
            setSurvey(item);
          }
        });
      }
      listPoint.sort(
        (a, b) => parseInt(a?.["points"]) - parseInt(b?.["points"]),
      );
      listSurvey.sort(
        (a, b) => parseInt(a?.["order-no"]) - parseInt(b?.["order-no"]),
      );
      setListPoint([...listPoint]);
      setListSurvey([...listSurvey]);
    } else {
      setLoading(true);
    }
  }, [listRating]);

  return (
    <div className={className}>
      {loading && <ModalLoading />}
      <div className={"view_content relative justify-center"}>
        <div className="bg-tipping justify-center ml-5 mr-5">
          <div className="tipping-line flex justify-center">
            <img src={icon_line} className="img-tipping-logo" alt="info" />
          </div>
          <div className="flex justify-center list-icon">
            {listPoint.map((item, index) => {
              return (
                <ItemRatingPoint
                  itemRating={item}
                  key={"item-" + item?.["points"]}
                  onSelected={() => {
                    onSelected(item, index);
                  }}
                />
              );
            })}
          </div>
          {/* {isChangeTitle && (
            <div className="font-700 fs-15  justify-center">
              {t("ratingContent2")}&nbsp;
            </div>
          )}
          {!isChangeTitle && (
            <div className="font-700 fs-15  justify-center">
              {t("ratingContent")}&nbsp;
            </div>
          )} */}
        </div>
        <div className="relative justify-center order-type1 ml-5 mr-5">
          {survey?.["questions"]?.map((itemQuestion, i) => {
            return (
              <div
                className={"item-question-and-answer-type-one"}
                key={"item-" + survey?.["id"] + i}
              >
                <div className={"variation-tab"}>
                  <div>
                    <div className="font-700 fs-15 absolute mt-3.5">
                      {itemQuestion?.["name"]}
                    </div>
                    <div className="payment-partner justify-end">
                      {itemQuestion?.["answers"].map((itemAnswer, index) => {
                        return (
                          <ItemAnswerType
                            itemAnswer={itemAnswer}
                            key={"item-" + itemAnswer?.["id"]}
                            onSelected={() => {
                              onSelectedAnswerType(
                                itemAnswer,
                                itemQuestion,
                                index,
                              );
                            }}
                          />
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
          <div className={"flex flex-col mt-5 ml-3 mr-3"}>
            <textarea
              type="text"
              maxLength={500}
              style={{
                fontSize: 14,
              }}
              placeholder={t("notifyContentRating")}
              onChange={(e) => setNoteForProduct(e.target.value)}
            ></textarea>
          </div>
        </div>
        <div className="relative justify-center questionAndAnswer m-5">
          {listSurvey.map((item, index) =>
            item?.["questions"].map((itemQuestion, i) => {
              return (
                <div
                  className={"item-question-and-answer"}
                  key={"item-" + item?.["id"]}
                >
                  <div className={"variation-tab"}>
                    <div className="tipping-title justify-center items-center text-center">
                      {itemQuestion?.["name"]}
                    </div>
                    <div className="gridAnswer justify-center">
                      {itemQuestion?.["answers"].map((itemAnswer, index) => {
                        return (
                          <ItemAnswer
                            itemAnswer={itemAnswer}
                            key={"item-" + itemAnswer?.["id"]}
                            onSelected={() => {
                              onSelectedAnswer(
                                item,
                                itemAnswer,
                                itemQuestion,
                                index,
                              );
                            }}
                          />
                        );
                      })}
                    </div>
                  </div>
                </div>
              );
            }),
          )}
        </div>
      </div>
      <div className={"w-full header bg-white relative"}>
        <div className={" flex justify-center items-center pb-3"}>
          <div
            className={
              " w-6 h-6 absolute left-0 flex justify-center items-center ml-3"
            }
            onClick={onClose}
          >
            <img src={icon_cancel_dialog} />
          </div>
          <div>
            <div className="tipping-title flex justify-center">
              {t("ratingTitle")}&nbsp;
            </div>
            <div className=" tipping-title flex justify-center">
              {t("ratingTitle1")}&nbsp;
            </div>
          </div>
        </div>
      </div>
      <div className=" btn flex bottom-0 w-full justify-center items-center">
        <div
          className={
            isEnableRefPoint.current &&
            isEnableRefSurvey.current &&
            isEnableRefListSurvey.current
              ? "btnRight flex justify-center items-center font-700 opacity-100 h-12 w-full"
              : "btnRight flex justify-center items-center font-700 opacity-50 h-12 w-full"
          }
          onClick={onSubmitRating}
        >
          {t("submitConfirm")}
        </div>
      </div>
    </div>
  );
});

export default styled(RatingOnModal)`
  display: flex;
  flex-flow: column;
  background: #ffffff;
  height: 100%;
  .order-type1 {
    background: #f2f2f2;
  }
  .view_content {
    flex: 0 1 auto;
    overflow: auto;
    background: #ffffff;
    padding-bottom: 65px;
    padding-top: 65px;
  }
  .header {
    top: 10;
    padding-top: 15px;
    position: fixed;
  }
  .text-title-name {
    color: #1a1a1a;
    font-weight: 700;
    font-size: 15px;
    line-height: 20px;
    font-family: "Manrope-Medium", sans-serif;
  }
  .tipping-title {
    color: #1a1a1a;
    font-weight: 700;
    font-size: 15px;
    line-height: 20px;
    font-family: "Manrope-Medium", sans-serif;
  }
  .grid {
    display: grid;
    margin-top: 10px;
    grid-template-columns: repeat(auto-fit, minmax(120px, 4fr));
    grid-gap: 10px;
  }
  .gridAnswer {
    display: grid;
    margin-top: 10px;
    grid-template-columns: repeat(auto-fit, minmax(80px, 4fr));
    grid-gap: 10px;
  }
  .gridAnswerTypeOne {
    display: grid;
    margin-top: 10px;
    grid-template-columns: repeat(auto-fit, minmax(30px, 4fr));
    grid-gap: 10px;
  }

  .content {
    max-height: calc(100vh - 300px);
    overflow-y: auto;
  }
  .item-question-and-answer {
    position: relative;
    margin-bottom: 10px;
    .itemAnswer {
      height: auto;
    }
  }
  .payment-partner {
    overflow: auto;
    display: flex;
  }

  .item-question-and-answer-type-one {
    position: flex;
    padding-bottom: 10px;
    padding-top: 10px;
    margin-left: 10px;
    .itemAnswer {
      height: auto;
    }
  }

  .item-cancel {
    position: absolute;
    top: 0;
    left: 0;
    margin: 10px;
  }
  .icon-rating {
    height: 76px;
    width: 100%;
  }
  .list-icon {
    width: 100%;
    height: 100px;
    background: #ffffff;
  }
  textarea {
    height: 60px;
    border: 1px solid #cfcfcf;
    border-radius: 4px;
    padding: 8px;
    font-weight: 400;
    font-size: 14px;
    outline: none !important;
    margin-bottom: 10px;
    line-height: 18px;
    font-family: "Manrope-Medium", sans-serif;
  }
  input:focus {
    outline: none !important;
    border: 1px solid #b98803;
  }
  textarea:focus {
    outline: none !important;
    border: 1px solid #b98803;
  }
  .btnCloseModal {
    margin-top: 10px;
  }

  .img-tipping-logo {
    margin-top: 10px;
  }
  .text-input {
    height: 44px;
    padding: 10px;
    display: flex;
    justify-content: start;
  }
  .btn_primary {
    width: "50%";
  }
  .tipping-input {
    background: #ffffff;
    border-radius: 4px;
    margin-top: 10px;
    margin-left: 10px;
    margin-right: 10px;
    margin-bottom: 10px;
  }
  .tipping-line {
    margin-bottom: 10px;
  }
  .textarea {
    border: none;
    overflow: auto;
    outline: none;
    background: none;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;

    resize: none; /*remove the resize handle on the bottom right*/
  }
  .btn {
    position: fixed;
    background: #ffffff;
    height: 60px;
    .btnRight {
      color: #ffffff;
      background: #1a1a1a;
      border-radius: 4px;
      margin: 15px;
      /* width: 90%; */
      /* height: 44px; */
    }
  }
`;
